import * as Sentry from '@sentry/react'
import axios from 'axios'

const release =
  import.meta.env.VITE_APP_VERSION || import.meta.env.APP_VERSION || 'unknown'

export function initializeSentry(dsn: string) {
  Sentry.init({
    dsn,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.thirdPartyErrorFilterIntegration({
        filterKeys: ['rever-dashboard'],
        behaviour: 'drop-error-if-contains-third-party-frames'
      })
    ],
    tracesSampleRate: 0.2,
    ignoreErrors,
    release
  })
}

export function notifyError(error: unknown) {
  if (axios.isAxiosError(error)) {
    const responsePayload = error.response?.data
    setTagsSentry({ endpoint: JSON.stringify(error.config?.url) })
    Sentry.captureException(error, {
      extra: {
        requestPayload: redactedPayload(error?.config?.data),
        responsePayload
      }
    })
  } else {
    Sentry.captureException(error)
  }
}

// A failed save of a credential, like a store's Shopify app deploy token, must not send it to Sentry.
const SECRET_KEY = /token|secret|password|api_?key/i
const REDACTED = '[redacted]'

// The request body, which axios holds as a JSON string, with the value of every secret-looking key replaced.
function redactedPayload(data: unknown) {
  if (data === undefined) return undefined
  if (typeof data !== 'string') return JSON.stringify(redact(data))
  try {
    return JSON.stringify(redact(JSON.parse(data)))
  } catch {
    // Not JSON, so its secrets can't be found: none of it is sent.
    return REDACTED
  }
}

function redact(value: unknown): unknown {
  if (Array.isArray(value)) return value.map(redact)
  if (value && typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value).map(([key, field]) => [
        key,
        SECRET_KEY.test(key) ? REDACTED : redact(field)
      ])
    )
  }
  return value
}

export function setUserSentry(email: string | undefined) {
  if (!email) return
  Sentry.setUser({
    email
  })
}

export function setTagsSentry(tags: { [key: string]: string }) {
  Sentry.setTags({
    ...tags
  })
}

const ignoreErrors = [
  "Can't find variable: showKeyboard",
  "Can't find variable: hideKeyboard",
  "Can't find variable: msDiscoverChatAvailable",
  /ERR_NETWORK/i,
  /Load failed/i
]
